// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import SimpleSlotTemplate, {SimpleSlotProps} from 'assembly/SimpleSlotTemplate';
import SingleFragmentSlotView from 'assembly/views/SingleFragmentSlotView';
import * as util from 'biojs/Util';
import {Sequence} from 'components/Sequence';
import * as sequtil from 'molbio/SeqUtil';

class SimpleSlotView extends SingleFragmentSlotView {
  template!: typeof SimpleSlotTemplate;

  static initClass(): void {
    this.prototype.template = SimpleSlotTemplate;
  }

  updateSequence(sequence: Sequence): void {
    super.updateSequence(sequence);
    if (this.selection != null) {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.listenTo(this.selection, 'change', this.updateToolbar);
    }
    this.updateToolbar();
  }

  toggleActive(): void {
    this.$el.toggleClass('active', this.model.active());
    this.$('.assembly-slot-options').toggleClass('options-visible', this.model.active());
  }

  updateToolbar(): void {
    // Disable moving backbone.
    this.$('.js-shift-left, .js-shift-right').toggleClass('hidden', this.model.index() === 0);

    const disableShiftLeft = this.model.index() === 1;
    this.$('.js-shift-left').toggleClass('disabled', disableShiftLeft).attr({disabled: disableShiftLeft});
    const disableShiftRight = this.model.index() === this.model.collection.length - 1;
    this.$('.js-shift-right').toggleClass('disabled', disableShiftRight).attr({disabled: disableShiftRight});

    this.$('[data-toggle="tooltip"]').tooltip({container: 'body'});
  }

  render(): this {
    this.$('[data-toggle="tooltip"]').tooltip('destroy');
    const fragment = this.model.isEmpty() ? null : this.model.singleFragment();

    let info = {
      index: this.model.index(),
      active: this.model.active(),
      empty: this.model.isEmpty(),
      slotName: this.model.displayName(),
      spacer: this.model.spacer(),
    };

    if (!this.model.isEmpty()) {
      const seqLength = fragment!.getSequence()!.length();
      // eslint-disable-next-line no-restricted-syntax
      info = _.extend(info, {
        name: fragment!.sequenceMetadata().name,
        start: fragment!.start(),
        end: fragment!.end(),
        reverse: fragment!.reverse(),
        seqLength,
        startIndex: fragment!.getSequence()!.startIndex(),
        length: sequtil.length(fragment!.start()!, fragment!.end()!, seqLength),
        // TODO: remove sequtil and util, these are not being used.
        sequtil,
        util,
        enzymes: fragment!.getEnzymes(),
      });
    }

    this.$el.html(this.template(info as unknown as SimpleSlotProps));
    this.toggleActive();
    this.updateToolbar();
    this.toggleDelete();
    return this;
  }
}
SimpleSlotView.initClass();

export default SimpleSlotView;
